import * as FaIcons from "react-icons/fa";
import { Link } from "react-router-dom";
import Logo from "../img/LogoVetViajante.svg";
import Styles from "../styles/header.module.css";

const Header = () => {
  return (
    <header className={Styles.menuPrincipal}>
      <div className={Styles.logo}>
        <Link to="/">
          <img src={Logo} alt="Logo Vet Viajante" />
        </Link>
      </div>

      <div className={Styles.redesSociais}>
        <ul>
          <li>
            <button type="button" className={Styles.linkDesativado}>
              <FaIcons.FaYoutube size={28} color="#d5d5d5ff" />
              <span className={Styles.tooltip}>Em breve</span>
            </button>
          </li>

          <li>
            <a
              href="https://wa.me/553491026420"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaIcons.FaWhatsapp size={28} color="#d5d5d5ff" />
            </a>
          </li>

          {/* <li>
            <a
              href="https://www.facebook.com/profile.php?id=100078661953394"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaIcons.FaFacebook size={28} color="#d5d5d5ff" />
            </a>
          </li> */}

          <li>
            <a
              href="https://www.instagram.com/vet_viajante/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaIcons.FaInstagram size={28} color="#d5d5d5ff" />
            </a>
          </li>

          <li>
            <a
              href="https://www.tiktok.com/@vetviajante"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaIcons.FaTiktok size={28} color="#d5d5d5ff" />
            </a>
          </li>
        </ul>
      </div>

      <div className={Styles.menu}>
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/quemSomos">Quem somos</Link>
          </li>
          <li>
            <Link to="/servicos">Serviços</Link>
          </li>
          <li>
            <Link to="/petshop">Pet Shop</Link>
          </li>
          <li>
            <a
              href="https://vetviajante1.hotmart.host/nova-pagina-b3263b01-5877-4f25-a785-6ace9d9d77d0"
              target="_blank"
              rel="noopener noreferrer"
              className={Styles.link}
            >
              Cursos
            </a>
          </li>

          <li>
            <Link to="/noticias">Notícias</Link>
          </li>
          <li>
            <Link to="/contatos">Contatos</Link>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Header;
